<template>
  <a-modal v-model="visible" :footer="null" @cancel="kang">
    <div v-if="paylink!==''" style="text-align: center;">
      <div style="color: rgb(253,138,26);font-weight: 700;margin-bottom: 30px">余额不足! 请您先完成充值</div>
      <button type="button" v-if="paylink!==''&& paylink!=='goToMiniPage'"
              class="btn btn-primary" style="background:rgb(253,138,26);border: none;margin-bottom: 10px"
              @click="goToMecheme">
        点击微信充值
      </button>
    </div>
    <div v-if="paylink==''">
      <div v-if="active === 0">
        <a-form-model
            :layout="form.layout"
            :model="form"
            :rules="rules"
            ref="ruleForm"
            v-bind="formItemLayout"
        >
          <div class="text-center" style="color: #2e2e2e;font-weight: 600;padding-bottom: 15px">充值金额</div>
          <a-form-model-item style=" margin-bottom: 0px;" prop="paying">
            <a-input
                v-model="form.paying"
                prefix="¥"
                placeholder="自定义金额"
                type="number"
            />
            <a-form-model-item style=" margin-bottom: 0px;" class="row">
              <div class="quick_amount col-xs-10 col-sm-10 col-md-10 col-lg-10"
              >
                <p class="col-xs-3 col-sm-3 col-md-3 col-lg-3"
                   v-for="item in moneyList"
                   :key="item.num"
                   @click="getMoney(item.num)" :class='[form.paying==item.num?"action":"noaction"]'
                >{{ item.num }}<span style="font-size: 50%;font-weight: 360"> 元</span></p>
              </div>
            </a-form-model-item>

          </a-form-model-item>
          <a-form-model-item class="text-center">
            <a-button style="width: 50%; background: rgb(29,142,242)"
                      type="primary"
                      :loading="loading"
                      @click="onSubmit"
            >
              确定
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div v-if="active === 1">
        <div class="text-center" style="width:100% ">
          <img style="width: 40px" src="../assets/images/wxpay.svg" alt="微信支付" class="wxPay">
          <span style="color: black">微信扫码支付</span>
        </div>
        <div id="qrcode" ref="qrcode"></div>
        <!--      <img src="../assets/images/other.png" class="logoimg"/>-->
        <!-- <button @click="getWx">获取</button> -->
      </div>
      <div v-if="active === 2">
        <div class="order-wrapper">
          <a-avatar :src="require('../assets/images/vector.svg')"/>
          <div class="suce">付款成功</div>
          <p>
            <span>{{ aout }}s</span>后关闭
          </p>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import QRCode from "qrcodejs2";
import {getQuery, getWxorder} from "@/api/pay";
import { getWxMiniLink} from "@/api/mine";


export default {
  props: ['data'], // 声明 data 作为组件的属性
  computed: {
    formItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
          }
          : {};
    },
    buttonItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            wrapperCol: {span: 14, offset: 4},
          }
          : {};
    },
  },
  mounted() {
    this.getLink();
  },
  data() {
    const checkDenominator = (rule, value, callback) => {
      if (value < 1) {
        return callback("最少充值1元哟");
      }
      callback();
    };
    return {
      paylink: '',
      moneyList: [
        {
          num: 10,
        },
        {
          num: 30,
        },
        {
          num: 50,
        },
        {
          num: 100,
        },
        {
          num: 200,
        },
        {
          num: 500,
        },
      ],
      visible: false,
      active: 0,
      loading: false,
      form: {
        layout: "vertical",
        paying: "1",
      },
      rules: {
        paying: [
          {required: true, message: "请填写充值金额", trigger: "change"},
          {
            validator: checkDenominator,
            // message: `数量范围：${min}-${max}`,
            trigger: ["change", "blur"],
          },
        ],
      },
      appSecret: "oeuednafwe52edadafdcasdwed",
      time: "",
      aout: 3,
    };
  },
  methods: {
    goToMecheme() {
      window.open(this.paylink, "_self");
    },
    isWeixin() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    getLink() {
      if (screen.width < 500) {
        if (this.isWeixin()) {
          this.paylink = 'goToMiniPage';
          return
        }
        var params = {
          union_id: this.unionid,
          user_name: this.nickname,
        };
        getWxMiniLink(params).then((res) => {
          if (res.code == 200) {
            this.paylink = res.data;
          }
        });
      }

    },
    kang() {
      this.active = 0;
      this.form.paying = "";
      clearInterval(this.time);
    },
    getMoney(num) {
      console.log("----", num)
      this.form.paying = num;
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let timeStamp = new Date().getTime();
          var params = {
            amount: this.form.paying * 100,
            timeStamp: timeStamp,
            sign: this.$md5(
                "ordertime=" +
                timeStamp +
                "&amount=" +
                parseInt(this.form.paying * 100) +
                "&appSecret=" +
                this.appSecret
            ),
          };
          getWxorder({...params}).then((res) => {
            if (res.code == 200) {
              // console.log(res);
              this.loading = false;
              this.active = 1;
              this.$nextTick(() => {
                this.getWx(res.data.code_url);
              });
              this.time = setInterval(() => {
                this.Setcode(res.data.nq);
              }, 5000);
            }
          });
        } else {
          return false;
        }
      });
    },
    Setcode(nq) {
      var params = {
        nq: nq,
      };
      getQuery(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.$refs.qrcode.innerHTML = "";
          this.active = 2;
          this.$message.success(res.msg)
          clearInterval(this.time);
          setInterval(() => {
            if (this.aout > 0) {
              this.aout--;
            } else {
              this.kang();
              this.visible = false;
            }
          }, 1000);
        }
      });
    },
    getWx(url) {
      //   this.$refs.qrcode.innerHTML = '';
      var qrcode = new QRCode(this.$refs.qrcode, {
        // 第一个入参是组件id
        text: url, // 生成二维码的文本
        width: 150,
        height: 150,
        colorDark: "#000000", // 二维码色
        colorLight: "#ffffff", // 背景色
        correctLevel: QRCode.CorrectLevel.H, // 容错等级，H是heigh，最高，所以二维码看起来很密
      });
    },
  },
};
</script>
<style scoped>
.el-steps--horizontal {
  margin-top: 20px;
}

.ant-form {
  margin: 20px 0;
}

.defray {
  float: right;
}

#qrcode {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.ant-form-item > * {
  margin-bottom: 5px;
}

.order-wrapper {
  margin: 40px 0;
  text-align: center;
  font-size: 30px;
}

.ant-avatar {
  width: 40px;
  height: 40px;
  margin-bottom: 10px;
}

.order-wrapper p {
  font-size: 18px;
}

.order-wrapper p span {
  color: brown;
}

.qrcode {
  display: inline-block;
  position: relative;
  margin-top: 0.2rem;
}

.logoimg {
  position: absolute;
  left: 52%;
  top: 64%;
  width: 40px;
  height: 40px;
  margin-top: -30px;
  margin-left: -30px;
  background: #ffffff;
}

.wxPay {
  margin: auto;
  display: flex;
  /*padding-left: 30px;*/
  width: 100%;
}

* {
  margin: 0;
  padding: 0
}

ol, ul {
  list-style: none;
}

.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-13, .col-xs-14 {
  float: none;
}

.mask {
  background: #f0eff5;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}

.h1 {
  padding-top: 50px
}

.container {
  width: 90%;
  margin: 0 auto;
  background: #fff;
  margin-top: 5%;
}

.container_logo {
  background: #fbfbfb
}

.play {
  margin: 0 auto;
  padding: 10px 0px;
}

.play img {
  width: 80%;
  display: block;
  margin: 0 auto;
}

.number_amount {
  position: relative;
  height: 42px;
}

.number_amount label {
  position: absolute;
  top: 50%;
  margin-top: -18px;
  font-size: 24px;
  left: 0;
}

.play input[type="number"] {
  width: 100%;
  height: 100%;
  font-size: 24px;
  border: none;
  border-bottom: 1px solid #eee;
  outline: none;
  padding: 0 30px;
}

.quick_amount {
  margin: 0 auto;
  padding: 0;
}


.quick_amount p.noaction {
  display: inline-block;
  text-align: center;
  font-size: 120%;
  font-weight: 700;
  color: rgb(29, 142, 242);
  line-height: 40px;
  margin: 10px 3.3%;
  background: rgb(247, 249, 245);
  border-radius: 2px;
}

.quick_amount p.action {
  display: inline-block;
  text-align: center;
  font-size: 120%;
  font-weight: 700;
  line-height: 40px;
  margin: 10px 3.3%;
  background: rgb(247, 249, 245);
  color: rgb(253, 138, 26);
  border-radius: 2px;
}

._submit {
  margin: 30px auto;
}

.submit-amount {
  width: 100%;
}
</style>

